export default class Layout {
  constructor() {
    this.bps = {
      above: {
        sm: window.matchMedia('(min-width: 1px)'),
        md: window.matchMedia('(min-width: 768px)'),
        tablet: window.matchMedia('(min-width: 1200px)'),
        lg: window.matchMedia('(min-width: 1440px)'),
      },
      below: {
        sm: window.matchMedia('(max-width: 767px)'),
        md: window.matchMedia('(max-width: 1439px)'),
        lg: window.matchMedia('(max-width: 1023px)'),
      },
    };

    this.watchBreakpoints();
  }

  static getInstance() {
    if (!this.instance) this.instance = new Layout();
    return this.instance;
  }

  watchBreakpoints() {
    const allBps = Object.values(this.bps.above).concat(
      Object.values(this.bps.below),
    );
    allBps.map((bp) =>
      bp.addEventListener('change', (e) => {
        if (e.matches) {
          const bpChange = new CustomEvent('bpChange', {
            detail: { bp: this.isBreakpoint() },
          });
          window.dispatchEvent(bpChange);
        }
      }),
    );
  }

  isBreakpoint() {
    return (
      Object.entries(this.bps.above)
        .reverse()
        .find(([, value]) => value.matches)?.[0] ?? 'xs'
    );
  }

  isAboveBreakpoint(bp) {
    return this.bps.above[bp].matches;
  }

  isBelowBreakpoint(bp) {
    return this.bps.below[bp].matches;
  }
}
